import { render, staticRenderFns } from "./ChannelInvitelist.vue?vue&type=template&id=b4c10b2e&"
import script from "./ChannelInvitelist.vue?vue&type=script&lang=js&"
export * from "./ChannelInvitelist.vue?vue&type=script&lang=js&"
import style0 from "./ChannelInvitelist.vue?vue&type=style&index=0&id=b4c10b2e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports